var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7H3.75C3.3125 7 3 7.34375 3 7.75C3 8.1875 3.3125 8.5 3.75 8.5H8.25C8.65625 8.5 9 8.1875 9 7.75C9 7.34375 8.65625 7 8.25 7ZM5.25 10H3.75C3.3125 10 3 10.3438 3 10.75C3 11.1875 3.3125 11.5 3.75 11.5H5.25C5.65625 11.5 6 11.1875 6 10.75C6 10.3438 5.65625 10 5.25 10ZM8.25 4H3.75C3.3125 4 3 4.34375 3 4.75C3 5.1875 3.3125 5.5 3.75 5.5H8.25C8.65625 5.5 9 5.1875 9 4.75C9 4.34375 8.65625 4 8.25 4ZM10 0H2C0.875 0 0 0.90625 0 2V14C0 15.125 0.875 16 2 16H10C11.0938 16 12 15.125 12 14V2C12 0.90625 11.0938 0 10 0ZM10.5 14C10.5 14.2812 10.25 14.5 10 14.5H2C1.71875 14.5 1.5 14.2812 1.5 14V2C1.5 1.75 1.71875 1.5 2 1.5H10C10.25 1.5 10.5 1.75 10.5 2V14Z",
    fill: "#464B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.42bbbbab460b8e8635d5556bc749f21f.svg";
export { ForwardRef as ReactComponent };